import { render, staticRenderFns } from "./SecondaryButton.vue?vue&type=template&id=eae852f4&scoped=true"
import script from "./SecondaryButton.vue?vue&type=script&lang=js"
export * from "./SecondaryButton.vue?vue&type=script&lang=js"
import style0 from "./SecondaryButton.vue?vue&type=style&index=0&id=eae852f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae852f4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SecondaryButton.vue
// module id = 7
// module chunks = 0